// extracted by mini-css-extract-plugin
module.exports = {"wrap":"GPav","imgBg":"GPabf","image":"GPob","textBox":"GPabh","title":"GPal","statistic":"GPa5"};